/**
 * Leeft design tokens, transcribed from docs/design/leeft-design-tokens.md.
 * This is the single source of truth for the portal's MUI theme
 * (src/theme/leeftTheme.ts). Keep the two in sync when the tokens doc
 * changes. Only the values actually used by the portal are copied here;
 * SFTPGo WebAdmin/WebClient specific notes are not repeated.
 */

export const colorTokens = {
  brand: "#0A4145",
  brandHover: "#062E31",
  brandSubtle: "#E6F0F0",
  onBrand: "#FFFFFF",
  button: "#1F4047",
  buttonHover: "#142B30",
  text: "#111111",
  textMuted: "#5C6A6C",
  bg: "#F3F4F3",
  surface: "#FFFFFF",
  borderControl: "#869395",
  borderDivider: "#D5DDDE",
  danger: "#B42318",
  success: "#1E7A46",
  warningBg: "#F5B83D",
  warningText: "#8A5A00",
  info: "#1F5F9E",
} as const;

export const radiusTokens = {
  sm: 4,
  md: 8,
  lg: 12,
  input: 14,
  pill: 999,
} as const;

export const controlHeight = 56;

export const spacingTokens = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  6: 24,
  8: 32,
  12: 48,
} as const;

export const fontFamily = '"Inter", "Helvetica Neue", Arial, sans-serif';

export const focusRing = `0 0 0 2px ${colorTokens.surface}, 0 0 0 4px ${colorTokens.brand}`;
